import {Component, Input} from '@angular/core';
import {SummaryCardTemplateComponent} from '../common/summary-card-template/summary-card-template.component';
import {BaseError} from '../../models/error/BaseError';

@Component({
    selector: 'app-error-summary-card',
    templateUrl: './error-summary-card.component.html',
    styleUrls: ['./error-summary-card.component.css'],
    imports: [SummaryCardTemplateComponent],
    standalone: true,
})
export class ErrorSummaryCardComponent {
    @Input({required: true, alias: "loggableEntity"}) error!: BaseError;

    constructor() {
    }
}
